<a
  [ngClass]="'fxC' + level"
  [style.backgroundColor]="
    !data?.style || data?.style === 'link' ? '' : data.color
  "
  [style.color]="!data?.style || data?.style === 'link' ? data.color : ''"
  [attr.data-testid]="'flex-button'"
>
  <div
    #font
    class="font"
    [style.fontSize.px]="fontSize"
    [attr.data-testid]="'flex-button-label'"
  >
    {{ $any(data?.action)?.label }}
  </div>
</a>

@if (hasShareAction(data)) {
  <ms-share-preview
    [messageId]="data.action['messageId']"
    [shareCurrentMessage]="data.action['shareCurrentMessage']"
    [package]="flexEditorService.package"
    class="absolute right-0 top-1/2 -translate-y-1/2"
  ></ms-share-preview>
}
